import { IApplicationState } from '../../types/redux';

export function getTags(state: IApplicationState) {
  return state.filters.tags;
}
